import { render, staticRenderFns } from "./AccountArchive.vue?vue&type=template&id=6b6f860e&scoped=true&"
import script from "./AccountArchive.vue?vue&type=script&lang=js&"
export * from "./AccountArchive.vue?vue&type=script&lang=js&"
import style0 from "./AccountArchive.vue?vue&type=style&index=0&id=6b6f860e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b6f860e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VAlert,VAvatar,VBtn})
